import { IsBoolean, IsDefined, IsInt, IsOptional } from 'class-validator';

export class BillingSubscriptionMerchantCreateDto {
  @IsDefined()
  @IsInt()
  billingSubscriptionId: number;

  @IsOptional()
  @IsInt()
  billingSubscriptionFrequencyId: number;

  @IsDefined()
  @IsInt()
  billingProductId: number;

  @IsDefined()
  @IsInt()
  merchantId: number;

  @IsOptional()
  @IsBoolean()
  isActive: boolean;
}